export default {
  closeStore: 'Close Store',
  sellerApply: 'Submit Application',
  storeCloseConditionsReview: 'Closing Conditions Review',
  questionnaireCompletion: 'Complete Questionnaire',
  infoVerification: 'Information Authentication',
  platformReview: 'Official Review',
  storeClosed: 'Store Closed',
  securityDepositRefund: 'Deposit Refund',
  cancelApply: 'Cancel',
  next: 'Next ',
  sellerApplyTitle: '1.Kindly read the following information in detail.',
  sellerApplyContent1: 'You are submitting an application to permanently close your Kilimall store and delete all associated data. Upon successful closure, all store information will be deactivated. Even if you reopen a store in the future, historical data cannot be recovered.',
  sellerApplyContent2: 'If you proceed with store closure, you will lose access to the following products and services related to your current store:',
  sellerApplyContent3: '1) Store payment records, fund accounts, etc.;',
  sellerApplyContent4: '2) Sales orders, refund/return orders, customer subscription relationships, and other customer data;',
  sellerApplyContent5: '3) Product images, descriptions, and buyer reviews.',
  sellerApplyContent6: `Process-related notifications will be sent to the main account's registered email and phone number. Please ensure your current account email and phone number are active and accessible.`,
  sellerApplyContent7: 'Please note: Once the store closure application is submitted, your store may be deactivated. After closure, the store cannot be reopened, and original data cannot be recovered. We strongly advise confirming all details before submitting your store closure request.',
  selfVerifyMeet: '2.Please self-verify whether you meet the requirements for store closure.',
  closureRequirements: 'Closure Requirements',
  exceptionStatus: 'Exception Status',
  recommendedAction: 'Recommended Action',
  storeOperatingGreaterMonths: 'Store operating ≥6 months',
  lastCompletedAgo: 'Last order completed ≥3 months ago',
  noStockWarehouse: 'No stock in FBK warehouse',
  none: '---',
  previousBtn: 'Previous>>>',
  storeOperatingLessMonths: 'Store operating <6 months',
  lastOrderLessMonths: 'Last order completed <3 months ago',
  fbkWarehouseStock: 'FBK warehouse has remaining stock',
  recommendTemporarilyClose: 'Recommend  temporarily closed for {0} days',
  returnWarehouseInventory: 'Return goods to warehouse or scrap inventory',
  noteStockShown: 'Note: The stock shown here is the front-end stock of the mall. There is a small probability that it will deviate from the actual stock. If there is any abnormality, please contact customer service for investigation.',
  clickToDetail: `Click to view the `,
  detailedRulesStoreClosure: `"Detailed Rules for Store Closure"`,
  temporarilyClosingStore: 'Temporarily Closing Store',
  productsInactive: 'All products in the store are inactive',
  storeActiveProducts: 'Store has active products',
  setAllActive: 'Set all products to inactive',
  threeReasonStoreClose: '3. Please select your reason for store closure',
  currentlyOperateStore: 'I currently have no time to operate the store',
  fewOrdersRevenue: 'Few orders and low revenue',
  anotherStore: 'I have another store.',
  openNewStore: 'I want to open a new store.',
  longerOperateStore: 'I no longer want to operate this store.',
  platformCustomerPoor: `The platform's customer service is poor.`,
  platformWebsiteSlow: 'The platform website is slow.',
  platformPaymentLong: `The platform's payment processing time is long.`,
  platformCountryLocations: 'The platform has limited country locations.',
  otherReasonSpecify: 'Other reasons (Please specify).',
  enterReason: 'Enter Reason',
  checkAccountNumber: '4. Please check the account number for deposit payment. The deposit will be refunded to this account. If there are special circumstances, it can be modified.',
  bankAccountNo: 'Bank Account No.',
  bankAccountName: 'Bank Account Name',
  bankBranchName: 'Bank Branch Name',
  modify: 'Modify',
  changeDepositAccount: 'Change Deposit Refund Account',
  noteBankAccount: `Note:`,
  noteBankAccountOne: '1.Please ensure that the name of the deposit payment bank card account is the same as the name of the deposit refund account.',
  noteBankAccountTwo: '2.Do not provide credit card numbers – refunds will otherwise fail.',
  cancel: 'Cancel',
  confirm: 'Confirm',
  depositRefundAccount: 'Your deposit refund account is',
  identityVerificationCode: '5. Identity Verification via Security Code',
  phoneNumber: 'Phone Number',
  verificationCode: 'Verification Code',
  send: 'Send',
  confirmStoreClosure: 'Confirm Store Closure',
  storeClosureApplySuccess: 'Store closure application successful!',
  officialProcessContactPassed: 'You have applied to close the store {0} country station {1},The official will process your store closure application within 2-3 months, and will contact you by phone/email after the review is passed.',
  failedOfficialReview: 'Failed official review',
  reasonFailure: 'Reason for failure',
  reapply: 'Reapply',
  ruleInput: 'Please input',
  storeClosureApproved: 'Store closure application successful!',
  approvedTips: 'Your application to close the store {0} national station {1} has been reviewed and approved by the platform. The platform finance department will proactively contact you for a refund. Please keep your phone/email service open.',
  operateSuccessful: 'Operate Successful'
}
